module.exports = __webpack_public_path__ + "static/img/Image_Developer.0842a6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Image_Developer.png
// module id = rKPG
// module chunks = 0